import * as types from '../types';
import { IAutoInvoicingApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class AutoInvoicingHttpApi extends HttpApi implements IAutoInvoicingApi {
  async previewAutoInvoicing(): Promise<types.AutoInvoicePreview> {
    const response = await this.http.get<types.APIResponse<types.AutoInvoicePreview>>('/auto-invoicing/preview');
    return response.data.data;
  }

  async runAutoInvoicing(data: types.RunAutoInvoicingRequest): Promise<types.AutoInvoiceRunResult> {
    const response = await this.http.post<types.APIResponse<types.AutoInvoiceRunResult>>('/auto-invoicing/run', data);
    return response.data.data;
  }

  async listAutoInvoicingRuns(limit?: number): Promise<types.AutoInvoiceRunSummary[]> {
    const response = await this.http.get<types.APIResponse<types.AutoInvoiceRunSummary[]>>('/auto-invoicing/runs', {
      params: limit === undefined ? undefined : { limit },
    });
    return response.data.data;
  }
}
